export default __webpack_public_path__ + "static/media/vendor_story_1.a2a5157b.svg";